/* Front-page stat count-up
   Watches .scroll-animate-item triggers via MutationObserver.
   Hero stats fire once on window load (they're above the fold, no scroll trigger). */
(function() {
    'use strict';

    // Parse a stat string like "$2.3M+" → { prefix:"$", num:2.3, suffix:"M+", decimals:1 }
    function parseStatValue(text) {
        var m = (text || '').trim().match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/);
        if (!m) return null;
        return {
            prefix:   m[1],
            num:      parseFloat(m[2]),
            suffix:   m[3],
            decimals: m[2].indexOf('.') >= 0 ? m[2].split('.')[1].length : 0
        };
    }

    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

    function countUpEl(el, delay) {
        if (!el.dataset.countTarget) {
            el.dataset.countTarget = el.textContent.trim();
        }
        var parsed = parseStatValue(el.dataset.countTarget);
        if (!parsed) return;

        if (el._countRaf) { cancelAnimationFrame(el._countRaf); el._countRaf = null; }

        var duration = 2000;

        function run() {
            var startTime = null;
            function tick(ts) {
                if (!startTime) startTime = ts;
                var progress = Math.min((ts - startTime) / duration, 1);
                var current  = parsed.num * easeOutQuart(progress);
                el.textContent = parsed.prefix + current.toFixed(parsed.decimals) + parsed.suffix;
                if (progress < 1) {
                    el._countRaf = requestAnimationFrame(tick);
                } else {
                    el.textContent = el.dataset.countTarget;
                    el._countRaf = null;
                }
            }
            el._countRaf = requestAnimationFrame(tick);
        }

        if (delay) { setTimeout(run, delay); } else { run(); }
    }

    function resetEl(el) {
        if (el._countRaf) { cancelAnimationFrame(el._countRaf); el._countRaf = null; }
        var target = el.dataset.countTarget;
        if (!target) return;
        var parsed = parseStatValue(target);
        if (parsed) {
            el.textContent = parsed.prefix + (0).toFixed(parsed.decimals) + parsed.suffix;
        }
    }

    // Watch a .scroll-animate-item element; count up statEls when it gets .vis, reset when lost
    function watchForVis(triggerEl, statEls, staggerMs) {
        if (!triggerEl || !statEls.length) return;
        var gap = (staggerMs !== undefined) ? staggerMs : 150;
        new MutationObserver(function() {
            if (triggerEl.classList.contains('vis')) {
                statEls.forEach(function(el, i) { countUpEl(el, i * gap); });
            } else {
                statEls.forEach(resetEl);
            }
        }).observe(triggerEl, { attributes: true, attributeFilter: ['class'] });
    }

    function toArr(nl) { return [].slice.call(nl); }

    document.addEventListener('DOMContentLoaded', function() {

        // ── Hero statline ──────────────────────────────────────────────────────
        // Above the fold — fire once on page load, no reset needed
        window.addEventListener('load', function() {
            toArr(document.querySelectorAll('.home-hero-statline .stat-value')).forEach(function(el, i) {
                countUpEl(el, 500 + i * 150);
            });
        });

        // ── About stats ────────────────────────────────────────────────────────
        // ul.home-about-stats is itself the scroll-animate-item
        var aboutStats = document.querySelector('ul.home-about-stats.scroll-animate-item');
        if (aboutStats) {
            watchForVis(aboutStats, toArr(aboutStats.querySelectorAll('.stat-value')), 150);
        }

        // ── Diagram stats ──────────────────────────────────────────────────────
        // Stats live inside .home-diagram-content which is the scroll-animate-item
        var diagramContent = document.querySelector('.home-diagram-content.scroll-animate-item');
        if (diagramContent) {
            watchForVis(
                diagramContent,
                toArr(diagramContent.querySelectorAll('.home-diagram-stats .stat-value')),
                150
            );
        }

        // ── Results stats ──────────────────────────────────────────────────────
        // Each .stat-card is its own scroll-animate-item; watch each independently
        toArr(document.querySelectorAll('.home-results-stats .stat-card.scroll-animate-item')).forEach(function(card) {
            var el = card.querySelector('.stat-value');
            if (el) watchForVis(card, [el], 0);
        });

        // ── Built points ───────────────────────────────────────────────────────
        // Each .point-item is its own scroll-animate-item; watch each independently
        toArr(document.querySelectorAll('.home-built-points .point-item.scroll-animate-item')).forEach(function(item) {
            var el = item.querySelector('.stat-num');
            if (el) watchForVis(item, [el], 0);
        });

    });

})();
